import React from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

const ComptabiliteTableau = ({ 
  postesDepenses, 
  coproprietaires, 
  factures, 
  recettes, 
  selectedYear, 
  coproId, 
  apiClient, 
  getErrorMessage 
}) => {
  const totalDepenses = factures.reduce((sum, f) => sum + parseFloat(f.montant || 0), 0);
  const totalRecettes = recettes.reduce((sum, r) => sum + parseFloat(r.montant || 0), 0);
  const solde = totalRecettes - totalDepenses;

  const getPosteTotal = (posteId) => factures.filter(f => f.poste_id === posteId).reduce((s, f) => s + parseFloat(f.montant || 0), 0);
  const getCoproTotal = (coproId) => recettes.filter(r => r.coproprietaire_id === coproId).reduce((s, r) => s + parseFloat(r.montant || 0), 0);

  const handleExport = async () => {
    try {
      const response = await apiClient.get('/coproprietes/' + coproId + '/comptabilite/export?annee=' + selectedYear, { 
        responseType: 'blob' 
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'comptabilite_' + selectedYear + '.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('Export téléchargé');
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erreur export'));
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">Tableau de trésorerie {selectedYear}</h2>
        <Button onClick={handleExport} className="bg-emerald-600 hover:bg-emerald-700">
          Télécharger Excel
        </Button>
      </div>

      <div className="bg-white rounded-xl border overflow-x-auto">
        <table className="w-full min-w-[500px]">
          <thead className="bg-slate-100">
            <tr>
              <th className="px-6 py-4 text-left font-semibold">Catégorie</th>
              <th className="px-6 py-4 text-left font-semibold">Détail</th>
              <th className="px-6 py-4 text-right font-semibold">Dépenses</th>
              <th className="px-6 py-4 text-right font-semibold">Recettes</th>
            </tr>
          </thead>
          <tbody>
            {postesDepenses.filter(p => getPosteTotal(p.id) > 0).map(poste => (
              <tr key={'dep-' + poste.id} className="border-t hover:bg-slate-50">
                <td className="px-6 py-4 font-medium">Dépenses</td>
                <td className="px-6 py-4 text-slate-600">{poste.nom}</td>
                <td className="px-6 py-4 text-right text-red-600 font-medium">{getPosteTotal(poste.id).toFixed(2)} €</td>
                <td className="px-6 py-4 text-right">-</td>
              </tr>
            ))}
            {coproprietaires.filter(c => getCoproTotal(c.id) > 0).map(copro => (
              <tr key={'rec-' + copro.id} className="border-t hover:bg-slate-50">
                <td className="px-6 py-4 font-medium">Recettes</td>
                <td className="px-6 py-4 text-slate-600">{copro.prenom} {copro.nom}</td>
                <td className="px-6 py-4 text-right">-</td>
                <td className="px-6 py-4 text-right text-emerald-600 font-medium">{getCoproTotal(copro.id).toFixed(2)} €</td>
              </tr>
            ))}
            <tr className="bg-slate-100 font-bold border-t">
              <td className="px-6 py-4">TOTAL</td>
              <td className="px-6 py-4"></td>
              <td className="px-6 py-4 text-right text-red-600">{totalDepenses.toFixed(2)} €</td>
              <td className="px-6 py-4 text-right text-emerald-600">{totalRecettes.toFixed(2)} €</td>
            </tr>
            <tr className={solde >= 0 ? 'bg-emerald-50 font-bold' : 'bg-red-50 font-bold'}>
              <td className="px-6 py-4">SOLDE</td>
              <td className="px-6 py-4"></td>
              <td colSpan={2} className={'px-6 py-4 text-right text-xl ' + (solde >= 0 ? 'text-emerald-600' : 'text-red-600')}>
                {solde >= 0 ? '+' : ''}{solde.toFixed(2)} €
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComptabiliteTableau;
